let storedHideNavigation: boolean;
let storedDeviceType: string | undefined;

export function setHideNavigation(hideNavigation?: boolean): void {
  storedHideNavigation = Boolean(hideNavigation);
}

export function setDeviceType(device: string | undefined): void {
  storedDeviceType = device;
}

export function getHideNavigation(): boolean {
  return storedHideNavigation;
}

export function getDeviceType(): string | undefined {
  return storedDeviceType;
}
